import { atom } from 'jotai'

export const orderbookCollapsedStorageKey = 'zkex_v3_orderbook_collapsed'
export const orderbookCollapsed = atom<boolean>(
  window.sessionStorage.getItem(orderbookCollapsedStorageKey) === 'true' ||
    false,
)
